export enum GenericColors {
  Primary = 'primary',
  Secondary = 'secondary',
  Green = 'green',
  Blue = 'blue',
  Orange = 'orange',
  Purple = 'purple',
  Yellow = 'yellow',
  Pink = 'pink',
  Red = 'red',
  Gray = 'gray'
}
